import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

import { Button } from '../../../../../../components/Button';

export const StyledIntentTagsContainer = styled.div`
  margin-top: 8px;
`;

export const StyledIntentButton = styled(Button)`
  padding: 6px 12px;
  font-size: 10px;
  line-height: 15px;
  background-color: ${colorsPalettes.bluegrey[100]};
`;
